import { useState, useCallback } from 'react';
import { api } from '../api/api';

export const useTracking = () => {
  const [trackedProducts, setTrackedProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTrackedProducts = useCallback(async (activeOnly = false) => {
    setLoading(true);
    setError(null);
    try {
      const data = await api.fetchTrackedProducts(activeOnly);
      setTrackedProducts(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const addTrackedProduct = useCallback(async (productData) => {
    setLoading(true);
    setError(null);
    try {
      const newProduct = await api.addTrackedProduct(productData);
      setTrackedProducts(prev => [newProduct, ...prev]);
      return newProduct;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const updateTrackedProduct = useCallback(async (id, data) => {
    setError(null);
    try {
      const updated = await api.updateTrackedProduct(id, data);
      setTrackedProducts(prev =>
        prev.map(p => p.id === id ? updated : p)
      );
      return updated;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, []);

  const deleteTrackedProduct = useCallback(async (id) => {
    setError(null);
    try {
      await api.deleteTrackedProduct(id);
      setTrackedProducts(prev => prev.filter(p => p.id !== id));
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, []);

  const toggleActive = useCallback(async (id, currentActive) => {
    return updateTrackedProduct(id, { active: !currentActive });
  }, [updateTrackedProduct]);

  return {
    trackedProducts,
    loading,
    error,
    fetchTrackedProducts,
    addTrackedProduct,
    updateTrackedProduct,
    deleteTrackedProduct,
    toggleActive
  };
};
